import React from "react";
import cloneDeep from "lodash/cloneDeep";
import get from "lodash/get";
import styled from "styled-components";
import { URLAllowListInput } from "components/common";
import { Button, Checkbox, Col, ControlLabel, Input, Row } from "components/bootstrap";
import * as FormsUtils from "util/FormsUtils";
const StyledButton = styled(Button)`
  clear: both;
  display: block;
  margin-bottom: 15px;
`;
class HttpNotificationForm extends React.Component {
  constructor(props) {
    super(props);
    this.propagateChange = (key, value) => {
      const { config, onChange } = this.props;
      const nextConfig = cloneDeep(config);
      nextConfig[key] = value;
      onChange(nextConfig);
    };
    this.handleChange = (event) => {
      const { name } = event.target;
      const inputValue = FormsUtils.getValueFromInput(event.target);
      this.propagateChange(name, inputValue);
    };
    this.handleSecretInputChange = (event) => {
      const { name } = event.target;
      const inputValue = String(FormsUtils.getValueFromInput(event.target));
      const value = inputValue.length === 0 ? { delete_value: true } : { set_value: inputValue };
      this.setState({ [name]: inputValue });
      this.propagateChange(name, value);
    };
    this.onValidationChange = (validationState) => {
      const { setIsSubmitEnabled } = this.props;
      setIsSubmitEnabled(validationState !== "error");
    };
    this.resetSecret = (attribute) => {
      const { reset } = this.state;
      reset[attribute] = true;
      this.setState({ reset });
      this.propagateChange(attribute, { delete_value: true });
      this.setState({ [attribute]: "" });
    };
    this.undoResetSecret = (attribute) => {
      const { reset } = this.state;
      reset[attribute] = false;
      this.setState({ reset });
      this.propagateChange(attribute, { keep_value: true });
      this.setState({ [attribute]: "******" });
    };
    this.state = {
      api_secret: "",
      basic_auth: "",
      reset: {
        api_secret: false,
        basic_auth: false
      }
    };
  }
  componentDidMount() {
    var _a, _b;
    const { config, onChange } = this.props;
    const nextConfig = cloneDeep(config);
    nextConfig.basic_auth = ((_a = config.basic_auth) == null ? void 0 : _a.is_set) ? { keep_value: true } : null;
    nextConfig.api_secret = ((_b = config.api_secret) == null ? void 0 : _b.is_set) ? { keep_value: true } : null;
    onChange(nextConfig);
    this.setState({ basic_auth: config.basic_auth.is_set ? "******" : "" });
    this.setState({ api_secret: config.api_secret.is_set ? "******" : "" });
  }
  render() {
    const { config, validation } = this.props;
    const { api_secret, basic_auth } = config;
    const { reset } = this.state;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      URLAllowListInput,
      {
        label: "URL",
        onChange: this.handleChange,
        validationState: validation.errors.url ? "error" : null,
        validationMessage: get(validation, "errors.url[0]", "The URL to POST to when an Event occurs."),
        onValidationChange: this.onValidationChange,
        url: config.url,
        autofocus: false
      }
    ), /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        id: "skip_tls_verification",
        name: "skip_tls_verification",
        onChange: this.handleChange,
        checked: config.skip_tls_verification
      },
      "Skip TLS verification"
    ), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, (basic_auth == null ? void 0 : basic_auth.keep_value) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ControlLabel, null, "Basic authentication"), /* @__PURE__ */ React.createElement(
      StyledButton,
      {
        bsStyle: "default",
        type: "button",
        onClick: () => {
          this.resetSecret("basic_auth");
        }
      },
      "Reset Secret"
    )) : /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "basicAuth",
        label: /* @__PURE__ */ React.createElement("span", null, "Basic authentication ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
        name: "basic_auth",
        type: "password",
        onChange: this.handleSecretInputChange,
        value: this.state.basic_auth || "",
        help: "The Basic authentication string needs to follow this format: '<username>:<password>'.",
        buttonAfter: reset.basic_auth ? /* @__PURE__ */ React.createElement(
          Button,
          {
            type: "button",
            onClick: () => {
              this.undoResetSecret("basic_auth");
            }
          },
          "Undo Reset"
        ) : void 0
      }
    ))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "api_key",
        name: "api_key",
        label: /* @__PURE__ */ React.createElement("span", null, "API Key ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
        type: "text",
        onChange: this.handleChange,
        bsStyle: validation.errors.api_key ? "error" : null,
        help: get(validation, "errors.api_key[0]", "If an API secret is set, an API key must also be set."),
        value: config.api_key
      }
    ))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, (api_secret == null ? void 0 : api_secret.keep_value) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ControlLabel, null, "API Secret"), /* @__PURE__ */ React.createElement(
      StyledButton,
      {
        bsStyle: "default",
        type: "button",
        onClick: () => {
          this.resetSecret("api_secret");
        }
      },
      "Reset Secret"
    )) : /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "apiSecret",
        label: /* @__PURE__ */ React.createElement("span", null, "API Secret ", /* @__PURE__ */ React.createElement("small", { className: "text-muted" }, "(Optional)")),
        name: "api_secret",
        type: "password",
        onChange: this.handleSecretInputChange,
        bsStyle: validation.errors.api_secret ? "error" : null,
        help: get(validation, "errors.api_secret[0]", "If an API key is set, an API secret must also be set."),
        value: this.state.api_secret || "",
        buttonAfter: reset.api_secret ? /* @__PURE__ */ React.createElement(
          Button,
          {
            type: "button",
            onClick: () => {
              this.undoResetSecret("api_secret");
            }
          },
          "Undo Reset"
        ) : void 0
      }
    ), /* @__PURE__ */ React.createElement(
      Checkbox,
      {
        id: "api_key_as_header",
        name: "api_key_as_header",
        onChange: this.handleChange,
        checked: config.api_key_as_header
      },
      "Send API Key/Secret as Header"
    ))));
  }
}
HttpNotificationForm.defaultConfig = {
  url: "",
  api_key_as_header: false,
  api_key: "",
  api_secret: { keep_value: true },
  basic_auth: { keep_value: true },
  skip_tls_verification: false
};
export default HttpNotificationForm;
